module.exports = __webpack_public_path__ + "static/19-fbc951d08cbb5adbd597a5e34a73d0ab.jpg";